var React = require('react');

function Medical (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("rect",{"fill":"none","height":"24","width":"24"})),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M20,6h-4V4c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4v2H4C2.9,6,2,6.9,2,8v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8 C22,6.9,21.1,6,20,6z M10,4h4v2h-4V4z M16,15h-3v3h-2v-3H8v-2h3v-3h2v3h3V15z"})))]);
}

Medical.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Medical;

Medical.default = Medical;
